// Module
var code = `<ng-form name="\$ctrl.form">
  <form-section form-title="'Automatic transfer arrangement'">
    <form-section-field field-title="'Allow auto fund transfer'">
      <select
          required
          ng-model="\$ctrl.model.enabled"
          boolean-options>
      </select>
    </form-section-field>
    <form-section-field field-title="'Allow auto fund transfer from'" ng-if="\$ctrl.model.enabled">
      <multiselect
          items="\$ctrl.productOptions"
          ng-model="\$ctrl.model.relationDefinitionsIds">
      </multiselect>
    </form-section-field>
    <form-section-field field-title="'Max no of linked accounts'" ng-if="\$ctrl.model.enabled">
      <input
          required
          type="number"
          min="0"
          step="1"
          ng-model="\$ctrl.model.maxRelations" />
    </form-section-field>
    <form-section-field field-title="'Allow linking accounts of related CIFs'"
                        ng-if="\$ctrl.model.enabled">
      <select
          required
          ng-model="\$ctrl.model.allowExternalRelations"
          boolean-options>
      </select>
    </form-section-field>
    <form-section-field field-title="'Trigger auto fund transfer after'"
                        ng-if="\$ctrl.model.enabled && \$ctrl.triggerCommandTags.length > 0">
      <multiselect
          items="\$ctrl.triggerCommands"
          ng-model="\$ctrl.model.triggerCommands">
      </multiselect>
    </form-section-field>

    <form-section-field
      field-title="\$ctrl.ataLabels.replenishmentFlag"
      ng-if="\$ctrl.model.enabled">
      <select
        required
        ng-model="\$ctrl.model.replenishEnabled"
        ng-change="\$ctrl.updateReplenishment(\$ctrl.model.replenishEnabled, \$ctrl.model)"
        boolean-options>
      </select>
    </form-section-field>

    <form-section-field
      field-title="\$ctrl.ataLabels.replenishmentStrategy"
      ng-if="\$ctrl.model.enabled && \$ctrl.model.replenishEnabled">
      <select
        required
        ng-model="\$ctrl.model.replenishStrategy"
        ng-options="entry.value as entry.label for entry in \$ctrl.ataEnabledReplenishStrategies">
      </select>
    </form-section-field>

    <form-section-field
      field-title="\$ctrl.ataLabels.replenishmentThreshold"
      ng-if="\$ctrl.model.enabled && \$ctrl.model.replenishEnabled">
      <cash
        required
        ng-model="\$ctrl.model.replenishThreshold"
        min="0">
      </cash>
    </form-section-field>

    <form-section-field field-title="'Allowed credit operations'"
                        ng-if="\$ctrl.model.enabled && \$ctrl.creditCommandTags.length > 0">
      <multiselect
          items="\$ctrl.creditCommands"
          ng-model="\$ctrl.model.creditCommands">
      </multiselect>
    </form-section-field>

    <form-section-field class="form-section-field--info" ng-if="\$ctrl.model.enabled">
      <span>
        Please note that if there is more than one linked account,
        system will try to transfer maximum amount from the first
        linked account, and if not successful it will continue to
        other accounts in the order they were added as linked.
      </span>
    </form-section-field>

  </form-section>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/automatic-transfer-arrangement/automatic-transfer-arrangement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;